<template v-if="attribute">
  <span class="reference-select-wrapper" v-if="!isReadOnly">
    <hy-select :model-value="selectedItem" @update:model-value="attribute.value = $event?.value ?? null" :items="items" :labelFunction="label" :placeholder="placeholder"/>
  </span>
  <span v-else>{{translateOption(options.get(attribute.ref.value) ?? nullDisplayValue)}}</span>
</template>

<script>
import { computed, shallowRef, watchEffect } from "vue";
import Attribute from "../../xmlrdb-data/Attribute"
import HySelect from "../../basic-components/HySelect.vue";

export default {
  components: {
    HySelect
  },
  props: {
    attribute: Attribute,
    isReadOnly: Boolean,
    options: {
      type: Map,
      required: true,
    },
    placeholder: String,
    nullDisplayValue: { type: String, default: "-" },
  },
  setup(props) {

    function translateOption(optionString){
      if(props.attribute?.metadata.root.translationProvider) {
        return props.attribute?.metadata.root.translationProvider.getLabel(props.attribute?.metadata, optionString);
      }
      return optionString
    }
    
    watchEffect(() => {
      if (!props.options.has(props.attribute.value)) {
        props.attribute.value = props.options.keys().next()?.value;
      }
    })

    const items = computed(() =>{
      return Array.from(props.options.entries().map(([value, label]) => ({ value, label })));
    });

    const selectedItem = computed(() => {
      return items.value.find((e) => e.value === props.attribute.value) ?? null;
    });


    return {
      translateOption,
      items,
      selectedItem,
      label(obj) {
        return obj ? translateOption(obj?.label) : props.placeholder;
      }
    }
  }
}

</script>

<style scoped>
</style>